module.exports = __webpack_public_path__ + "static/media/us_done.6478df9a.svg";